import type { FavoriteChapter as FavoriteChapterData } from '@mathflat/domain/FavoriteProblem'
import { action, computed, makeObservable, observable } from 'mobx'

import { DTO } from '..'

export class FavoriteChapter extends DTO {
  curriculumId: FavoriteChapterData['curriculumId']
  bigChapterName: FavoriteChapterData['bigChapterName']
  problemIdList: FavoriteChapterData['problemIdList']
  semesterId: FavoriteChapterData['semesterId']
  subjectId: FavoriteChapterData['subjectId']

  constructor(data: FavoriteChapterData) {
    super()
    this.curriculumId = data.curriculumId
    this.bigChapterName = data.bigChapterName
    this.problemIdList = data.problemIdList
    this.semesterId = data.semesterId
    this.subjectId = data.subjectId

    makeObservable(this, {
      curriculumId: observable,
      bigChapterName: observable,
      problemIdList: observable,
      semesterId: observable,
      subjectId: observable,
      semesterSubjectId: computed,
      deleteProblemId: action,
    })
  }

  get semesterSubjectId() {
    return this.semesterId ?? this.subjectId
  }

  deleteProblemId = (problemId: FavoriteChapterData['problemIdList'][number]) => {
    this.problemIdList = this.problemIdList.filter((id) => id !== problemId)
  }
}
